import type { AgendaReadModel } from './types';

/**
 * Client REST de l'agenda (read-model public, lecture seule, sans nonce).
 * GET /gas/v1/agenda?lang=&scope=current|all|years=YYYY[,YYYY]
 */
function buildUrl(restBaseUrl: string, locale: string, scope: string): string {
    const base = String(restBaseUrl || '/wp-json/gas/v1').replace(/\/+$/, '');
    const url = new URL(`${base}/agenda`, window.location.origin);
    if (locale) {
        url.searchParams.set('lang', locale);
    }
    url.searchParams.set('scope', scope);
    return url.toString();
}

async function fetchAgenda(restBaseUrl: string, locale: string, scope: string): Promise<AgendaReadModel> {
    const res = await fetch(buildUrl(restBaseUrl, locale, scope), {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
    });
    if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
    }
    const json = (await res.json()) as AgendaReadModel | { data: AgendaReadModel };
    // GasReadModelRestController renvoie le DTO directement (pas d'enveloppe data).
    return (json as { data?: AgendaReadModel }).data ?? (json as AgendaReadModel);
}

export function fetchCurrent(restBaseUrl: string, locale: string): Promise<AgendaReadModel> {
    return fetchAgenda(restBaseUrl, locale, 'current');
}

/** Charge une année d'archive (read-model filtré, remplace l'AJAX gas_agenda_load_archive_year). */
export function fetchArchiveYear(restBaseUrl: string, locale: string, year: number | string): Promise<AgendaReadModel> {
    return fetchAgenda(restBaseUrl, locale, `years=${year}`);
}
